import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";

export type SireReview = {
    sequenceId: string,
    requestorId: string,
    requestor: string,
    pic: string,
    vesselId: string,
    vesselName: string,
    imoNumber: string,
    vesselType: string,
    addaldPertamina: string,
    reviewDate: string,
    classSurveyStatusId: string,
    classSurveyStatusDate: string,
    capSurveyReportId: string,
    capSurveyReportDate: string,
    allStatuoryCertificatesId: string,
    allStatuoryCertificatesDate: string,
    othersId: string | null,
    othersDate: string | null,
    inspectorid: string,
    companyName: string,
    ocimfSireReportId: string,
    ocimfSireReportDate: string,
    officerMatrixId: string,
    officerMatrixDate: string,
    reviewVersion: number,
    sireVersion: object,
    ocimfSireReportV1Review: string,
    ocimfSireReportV1Status: string,
    ocimfSireReportV2HardwareStatus: object,
    ocimfSireReportV2ProcessStatus: object,
    ocimfSireReportV2HumanStatus: object,
    ocimfSireReportV2HardwareRectifiedStatus: object,
    ocimfSireReportV2ProcessRectifiedStatus: object,
    ocimfSireReportV2HumanRectifiedStatus: object,
    officerMatrixReview: string,
    officerMatrixStatus: string,
    allStatutoryCertificatesReview: string,
    allStatutoryCertificatesStatus: string,
    classSurveyStatusReview: string,
    classSurveyStatusStatus: string,
    capSurveyReportReview: string,
    capSurveyReportStatus: string,
    othersReview: string | null,
    othersStatus: string | null,
    notes: string | null,
    reviewStatus: number, // enum?
    reviewResult: number, // enum?
    timeStart: string,
    timeEnd: string,
    resultId: string,
    created: string,
    createdBy: string,
    isDeleted: boolean,
    id: string,
    modified: string,
    modifiedBy: string,
    dwt: number,
    shipBuildDate: string,
    isRerequest: boolean,
    isSecondDownload: boolean,
};

const getListSireReviewAdmin = async (param: any) => {
    const query = `?search=${param.search}&status=${param.status}&type=${param.type}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}&month=${param.month}&year=${param.year}`;
    const URL = `/SireReview/GetAllSireReviewAdmin${query}`;
    return apiCall('get', URL);
};

const getListSireReviewReviewer = async (param: any) => {
    const query = `?search=${param.search}&inspectorId=${param.inspectorId}&status=${param.status}&type=${param.type}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/SireReview/GetAllSireReviewReviewer${query}`;
    return apiCall('get', URL);
};

const getListSireReviewRequestor = async (param: any) => {
    const query = `?search=${param.search}&requestorId=${param.requestorId}&status=${param.status}&type=${param.type}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}&month=${param.month}&year=${param.year}`;
    const URL = `/SireReview/GetAllSireReviewRequestor${query}`;
    return apiCall('get', URL);
};

const getListSireReviewRequestingCompany = async () => {
    const URL = `/RefData/GetDataRequestor`;
    return apiCall('get', URL);
};

const getSireReviewById = async (id: string) => {
    const URL = `/SireReview/GetSireReviewById/${id}`;
    return apiCall('get', URL);
};

const getListReviewer = async () => {
    const URL = `/SireReview/GetDataReviewer`;
    return apiCall('get', URL);
};

const getDataVesselSire = async () => {
    const URL = `/SireReview/GetDataVessel`;
    return apiCall('get', URL);
};

const putSireReviewReviewer = async (data: any) => {
    const URL = '/SireReview/UpdateReviewer';

    try {
        const response = await axiosInstance.post<any[]>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const putSireReviewAdmin = async (data: any) => {
    const URL = '/SireReview/UpdateAdmin';

    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const postSireReview = async (data: any) => {
    const URL = '/SireReview/Create';

    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const postSireReviewReCreate = async (data: any) => {
    // const URL = '/SireReview/ReCreate';
    const URL = '/SireReview/RequestReviewer';

    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const rejectSireReview = async (id: string, data: { status: string; rejectionComments: string }) => {
    const URL = `/SireReview/Reject/${id}`;
    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

const postSireReviewReOpen = async (id: string, data: FormData | any) => {
    const URL = `/SireReview/Reopen/${id}`;
    try {
        // Supports both FormData and JSON; backend expects [FromForm]
        const headers = (data instanceof FormData) ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/json' };
        const response = await axiosInstance.post<any>(URL, data, { headers });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};

export {
    getListSireReviewAdmin,
    getListSireReviewReviewer,
    getListSireReviewRequestor,
    getListSireReviewRequestingCompany,
    getSireReviewById,
    putSireReviewReviewer,
    postSireReview,
    postSireReviewReCreate,
    putSireReviewAdmin,
    getListReviewer,
    getDataVesselSire,
    rejectSireReview,
    postSireReviewReOpen,
    reassignSireReview
};

const reassignSireReview = async (id: string, data: any) => {
    const URL = `/SireReview/Reassign/${id}`;

    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};
